<template>
    <b-modal class="fixedModal" ref="myModal" size="lg" id="modal1" title="Gestión de alertas y notificaciones" centered :hide-footer="true" @hidden="onHidden">
      <div v-if="newForm">
        <b-row>
          <b-col>
            <b-form-group
              label="Titulo:"
              label-for="exampleInput1">
                <b-form-input id="exampleInput1"
                name="Titulo"
                type="text"
                v-model="NewObject.titulo"
                v-validate="'required'"
                placeholder="Titulo">
                </b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Mensaje:"
              label-for="exampleInput2">
                <b-form-input id="exampleInput2"
                type="text"
                v-model="NewObject.mensaje"
                placeholder="Mensaje">
                </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: right;">
            <b-button @click="newForm = false">Cancelar</b-button>
            <b-button @click="saveAviso">Guardar</b-button>
          </b-col>
        </b-row>
      </div>
      <b-tabs v-else>
        <b-tab title="Alertas" active>
          <div class="scroll">
            <br>
            <v-server-table ref="table1" url="avisos/" :options="alOpt" :columns="alCol">
              <span slot="titulo" slot-scope="props" v-html="props.row.titulo"></span>
              <span slot="mensaje" slot-scope="props" v-html="props.row.mensaje"></span>
              <span slot="Acciones" slot-scope="props">
                <b-button @click="deleteRow(props.row)">Eliminar</b-button>
              </span>
            </v-server-table>
            <b-row>
              <b-col style="text-align: right;">
                <b-button @click="newAviso('alerta')">Nueva alerta</b-button>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="Notificaciones">
          <div class="scroll">
            <br>
            <v-server-table ref="table2" url="avisos/" :options="notOpt" :columns="notCol">
              <span slot="titulo" slot-scope="props" v-html="props.row.titulo"></span>
              <span slot="mensaje" slot-scope="props" v-html="props.row.mensaje"></span>
              <span slot="Acciones" slot-scope="props">
                <b-button @click="deleteRow(props.row)">Eliminar</b-button>
              </span>
            </v-server-table>
            <b-row>
              <b-col style="text-align: right;">
                <b-button @click="newAviso('notificacion')">Nueva notificación</b-button>
              </b-col>
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>
</template>

<style>

</style>

<script>

export default {
  name: 'ManageAlerts',
  data () {
    return {
      NewObject: {
        tipo: null,
        titulo: '',
        mensaje: ''
      },
      newForm: false,
      notOpt: {
        requestKeys: {
          query: 'search',
          orderBy: 'ordering',
          limit: 'page_size'
        },
        responseAdapter: function (resp) {
          return {
            data: resp.results,
            count: resp.count
          };
        },
        customFilters: ['tipo'],
        filterable: false,
        initFilters: {
          tipo: 'notificacion'
        },
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100]
      },
      notCol: [
        'titulo',
        'mensaje',
        'Acciones'
      ],
      alOpt: {
        requestKeys: {
          query: 'search',
          orderBy: 'ordering',
          limit: 'page_size'
        },
        responseAdapter: function (resp) {
          return {
            data: resp.results,
            count: resp.count
          };
        },
        customFilters: ['tipo'],
        filterable: false,
        initFilters: {
          tipo: 'alerta'
        },
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100]
      },
      alCol: [
        'titulo',
        'mensaje',
        'Acciones'
      ]
    };
  },
  mounted: function () {
    this.$refs.myModal.show();
  },
  methods: {
    onHidden: function () {
      this.$parent.manageAlerts = false;
    },
    newAviso: function (tipo) {
      this.NewObject = {
        tipo: tipo,
        titulo: '',
        mensaje: ''
      };

      this.newForm = true;
    },
    saveAviso: function () {
      this.$http.post('avisos/', this.NewObject).then(result => {
        this.newForm = false;
      });
    },
    deleteRow: function (row) {
      this.$http.delete('avisos/' + row.id + '/').then(result => {
        this.$refs.table1.getData();
        this.$refs.table2.getData();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/ManageAlerts.vue